module.exports = __webpack_public_path__ + "static/media/mf.05b71edc.webp";